/**
 * Pre-saved background images library for DisplayV3
 * Users can choose from these images or upload their own
 */

// You can add your images here in two ways:
// 1. As URLs to images in your public folder: '/images/bg1.jpg'
// 2. As base64 data URLs (for small images)

export const BACKGROUND_IMAGES = [
  {
    id: 'none',
    name: 'None',
    thumbnail: null,
    image: null
  },
  {
    id: 'dark-wood',
    name: 'Dark Wood',
    thumbnail: '/images/backgrounds/Dark_Wood.png',
    image: '/images/backgrounds/Dark_Wood.png',
    description: 'Dark wood texture'
  },
  {
    id: 'light-brown-wood',
    name: 'Light Brown Wood',
    thumbnail: '/images/backgrounds/Light_Brown_Wood.png',
    image: '/images/backgrounds/Light_Brown_Wood.png',
    description: 'Light brown wood grain'
  },
  {
    id: 'old-light-wood',
    name: 'Old Light Wood',
    thumbnail: '/images/backgrounds/Old_Light_Wood.png',
    image: '/images/backgrounds/Old_Light_Wood.png',
    description: 'Vintage light wood texture'
  },
  {
    id: 'stone',
    name: 'Stone',
    thumbnail: '/images/backgrounds/Stone.png',
    image: '/images/backgrounds/Stone.png',
    description: 'Natural stone texture'
  },
  {
    id: 'white-marble',
    name: 'White Marble',
    thumbnail: '/images/backgrounds/White_Marble.png',
    image: '/images/backgrounds/White_Marble.png',
    description: 'Elegant white marble'
  }
];

export default BACKGROUND_IMAGES;
